export default __webpack_public_path__ + "static/media/pitikPhone.7c29733a.png";